// error_type=1 is used by mobile platform only to handle old version of their app
export const formatRemoveErrorTypeMobile = (message: string): string =>
  message.replace('|error_type=1', '');
